import { render, staticRenderFns } from "./AboutUsModal.vue?vue&type=template&id=b1420966&scoped=true&"
import script from "./AboutUsModal.vue?vue&type=script&lang=js&"
export * from "./AboutUsModal.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsModal.vue?vue&type=style&index=0&id=b1420966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1420966",
  null
  
)

export default component.exports